export default "__VITE_ASSET__BkPB5xCa__"